/**
 * Coordina un solo Picture-in-Picture attivo tra più infobox.
 * Usa ref mutabili per evitare race tra leave/enter di dispositivi diversi.
 */
export function createPictureInPictureSession() {
    let ownerAlias = null;

    return {
        getOwner() {
            return ownerAlias;
        },

        handleEnter(newAlias, releaseStreamingForAlias) {
            const previousOwner = ownerAlias;
            if (previousOwner && previousOwner !== newAlias) {
                releaseStreamingForAlias(previousOwner);
            }
            ownerAlias = newAlias;
        },

        handleLeave(alias) {
            if (ownerAlias === alias) {
                ownerAlias = null;
            }
        },
    };
}

export async function exitPictureInPictureIfActive() {
    if (document.pictureInPictureElement) {
        try {
            await document.exitPictureInPicture();
        } catch {
            // ignore
        }
    }
}
